// @flow

import queryString from 'query-string';
import { Component } from 'react';

import { isBrowser } from '@zapier/common-utils';

import type { Node } from 'react';

type Props = {
  children: (value: ?string) => Node,
  hashKey: string,
};

type State = {
  value: ?string,
};

const parseSearchHash = (key: string) => {
  return queryString.parse(window.location.hash)[key];
};

class WithHashValue extends Component<Props, State> {
  state = {
    value: isBrowser() ? parseSearchHash(this.props.hashKey) : null,
  };

  componentDidMount() {
    if (isBrowser()) {
      window.addEventListener('hashchange', this.onHashChange);
    }
  }

  componentWillUnmount() {
    if (isBrowser()) {
      window.removeEventListener('hashchange', this.onHashChange);
    }
  }

  onHashChange = () => {
    const nextHashValue = parseSearchHash(this.props.hashKey);
    const { hash } = window.location;

    // If the hash is cleared, then set the state to empty
    if (!hash) {
      this.setState({
        value: null,
      });
    }

    // If the hash changes but the key we are looking up within the hash does
    // not change, then don't fire set state. A client clicking anchor links
    // should not trigger a state change.
    if (hash && nextHashValue && nextHashValue !== this.state.value) {
      this.setState({
        value: nextHashValue,
      });
    }
  };

  render() {
    return this.props.children(this.state.value);
  }
}

export default WithHashValue;
